var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CpslButton, CpslDivider, CpslIcon, CpslQrCode, CpslSpinner } from '@usecapsule/react-components';
import { useEffect, useState } from 'react';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import { Heading, SecondaryText, MainContainer, QRContainer, ButtonWithIconContainer } from '../common.js';
import { openPopup } from '../../utils/openPopup.js';
const SHORTENING_AVAILABLE = true;
export const BiometricLoginStep = () => {
    const webAuthURLForLogin = useModalStore(state => state.webAuthURLForLogin);
    const currentStep = useModalStore(state => state.step);
    const setStep = useModalStore(state => state.setStep);
    const setLoginWindow = useModalStore(state => state.setLoginWindow);
    const capsule = useCapsuleStore(state => state.capsule);
    const [shortLoginLink, setShortLoginLink] = useState();
    const [shortHelpLink, setShortHelpLink] = useState();
    useEffect(() => {
        if (currentStep !== ModalStep.BIOMETRIC_LOGIN) {
            setShortLoginLink(null);
        }
        if (!webAuthURLForLogin) {
            return;
        }
        function shortenUrl() {
            return __awaiter(this, void 0, void 0, function* () {
                const shortUrl = yield capsule.shortenLoginLink(webAuthURLForLogin);
                setShortLoginLink(shortUrl);
                const shortHelpUrl = yield capsule.shortenLoginLink(`${webAuthURLForLogin}&skipAutoLogin=true`);
                setShortHelpLink(shortHelpUrl);
            });
        }
        if (SHORTENING_AVAILABLE) {
            shortenUrl();
        }
        else {
            setShortLoginLink(webAuthURLForLogin);
        }
    }, [webAuthURLForLogin]);
    const handlePasskeyClick = () => {
        const loginWindow = openPopup(shortLoginLink, 'CapsulePasskey', 'LOGIN_PASSKEY');
        setLoginWindow(loginWindow);
        setStep(ModalStep.AWAITING_BIOMETRIC_LOGIN);
    };
    const handleHelpClick = () => {
        openPopup(shortHelpLink, 'CapsulePasskey', 'LOGIN_PASSKEY');
        setStep(ModalStep.AWAITING_BIOMETRIC_LOGIN);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MainContainer, { children: [_jsx(Heading, { children: _jsx("span", { children: "Login With Passkey" }) }), _jsx(SecondaryText, { children: _jsxs("span", { children: ["If the Passkey you registered previously lives on this device, click Login With Passkey.", '\n\n', "Otherwise, scan the QR code below with another device that has your Passkey."] }) })] }), _jsx(CpslButton, { fullWidth: true, onClick: handlePasskeyClick, children: _jsxs(ButtonWithIconContainer, { children: ["Login With Passkey On This Device", _jsx(CpslIcon, { icon: "key" })] }) }), _jsx(CpslDivider, { children: "or" }), _jsx(QRContainer, { children: !shortLoginLink ? _jsx(CpslSpinner, {}) : _jsx(CpslQrCode, { url: shortLoginLink }) }), _jsx(SecondaryText, { children: _jsx("span", { children: "Scan with your phone\u2019s camera" }) }), _jsx(CpslButton, { fullWidth: true, onClick: handleHelpClick, variant: "secondary", children: "I Need Help Logging In" })] }));
};
